import React, { Component } from 'react';

import PropTypes from 'prop-types';
import {observer} from 'mobx-react';

import Header from './Header'
import Footer from './Footer'

import './Layout.sass'

import uiState from '../../core/uiState'
import {StatusConstants} from '../../core/uiState';

@observer
export default class Layout extends Component {

    static childContextTypes = {
        layoutHasActiveOverlay: PropTypes.bool,
        layoutSetHasActiveOverlay: PropTypes.func,
        layoutHasInvertedTop: PropTypes.bool,
        layoutSetHasInvertedTop: PropTypes.func,
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            hasActiveOverlay: false,
            hasInvertedTop: false,
        };

        this.setHasActiveOverlay = this.setHasActiveOverlay.bind(this);
        this.setHasInvertedTop = this.setHasInvertedTop.bind(this);
    }

    getChildContext() {
        return {
            layoutHasActiveOverlay: this.state.hasActiveOverlay,
            layoutSetHasActiveOverlay: this.setHasActiveOverlay,
            layoutHasInvertedTop: this.state.hasInvertedTop,
            layoutSetHasInvertedTop: this.setHasInvertedTop,
        };
    }

    shouldComponentUpdate() {
        return true
    }

    setHasActiveOverlay(bool) {
        if (bool) {
            document.body.style.overflowY = 'hidden';
        } else {
            document.body.style.overflowY = 'scroll';
        }

        this.setState({
            layoutHasActiveOverlay: bool
        })
    }

    setHasInvertedTop(boolOrInt) {
        if (typeof boolOrInt === 'number') {
            document.body.style.backgroundPositionY = boolOrInt + 'px';
        } else if (boolOrInt === false) {
            document.body.style.backgroundPositionY = 0;
        }

        this.setState({
            hasInvertedTop: boolOrInt !== false && boolOrInt !== 0,
        })
    }

    render() {
        return [
            <Header key="header" />,
            ...this.props.children,
            <Footer key="footer" />,
        ]
    }
}


// WEBPACK FOOTER //
// ./src/layouts/Default/Layout.js